exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col-form-label[data-v-b351f8a0] {\n  margin-top: 10px;\n}\n", ""]);

// exports
